import { render } from "./Home.vue?vue&type=template&id=8911655a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8911655a&scoped=true&lang=css"

import exportComponent from "/Users/admin/Downloads/project_output 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8911655a"]])

export default __exports__